// extracted by mini-css-extract-plugin
export var black = "_17-6";
export var brand = "_17-1";
export var ddefault = "_17-0";
export var error = "_17-3";
export var gray = "_17-2";
export var highContrast = "_17-8";
export var outline = "_17-7";
export var success = "_17-5";
export var warning = "_17-4";